import "./scss/main.scss";
import "./App.css";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Router from "./components/Router";
import SocketProvider from "./contexts/SocketContext";
import Header from "./components/Header/Header";
import AuthProvider from "./contexts/AuthContext";
import DataProvider from "./contexts/DataContext";

const basePath = process.env.REACT_APP_BASE_PATH || "/";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter basename={basePath}>
          <AuthProvider>
            <DataProvider> 
              <Header />  
              <SocketProvider>
                <Router />
              </SocketProvider>
            </DataProvider> 
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
